<template>
  <div :id="currentStep.categoryId">
    <MixesStepIngredients
      v-for="(category, index) in childrenCategories"
      :key="category.id"
      :kind="kind"
      :all-ingredients="allIngredients"
      :all-categories="allCategories"
      :current-category="category"
      :current-step-index="currentStepIndex + (index !== 0 ? '+' : '')"
    />
  </div>
</template>

<script setup>
import { noop } from '@vueuse/core'
import { computed } from 'vue'

import MixesStepIngredients from '@/components/mixes/MixesStepIngredients.vue'

const props = defineProps({
  kind: {
    type: String,
    default: 'musli',
  },

  allIngredients: {
    type: Array,
    required: true,
    default: () => [],
  },

  allCategories: {
    type: Array,
    required: true,
    default: () => [],
  },

  currentStep: {
    type: Object,
    required: true,
    default: noop,
  },

  currentStepIndex: {
    type: Number,
    default: 1,
  },
})

const childrenCategories = computed(() => {
  return props.allCategories.filter(({ id }) => props.currentStep.childrenCategoryIds.includes(id))
})
</script>
